/** Whether rankings banner state applies to the week being viewed on the pick sheet. */
export const isRankingsInfoForWeek = (rankingsInfo, week) =>
  Boolean(rankingsInfo && week != null && Number(rankingsInfo.week) === Number(week));
